package info.rezident.app.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val LocalAppTypography = staticCompositionLocalOf {
    AppTypography
}

interface TypographyBlueprint {
    val title: CssStyle<GeneralKind>
    val h1: CssStyle<GeneralKind>
    val h2: CssStyle<GeneralKind>
    val body1: CssStyle<GeneralKind>
    val body2: CssStyle<GeneralKind>
    val body1Medium: CssStyle<GeneralKind>
}

@Immutable
data object AppTypography : TypographyBlueprint {
    override val title = CssStyle {
        base {
            Modifier
                .fontFamily("FunnelDisplay-Bold")
                .fontSize(40.px)
                .fontWeight(FontWeight.Bold)
                .lineHeight(1.2)
        }

        Breakpoint.SM {
            Modifier.fontSize(60.px)
        }

        Breakpoint.MD {
            Modifier.fontSize(70.px)
        }

        Breakpoint.LG {
            Modifier.fontSize(100.px)
        }

        Breakpoint.XL {
            Modifier.fontSize(116.px)
        }
    }

    override val h1 = CssStyle {
        base {
            Modifier
                .fontFamily("FunnelDisplay-SemiBold")
                .fontSize(32.px)
                .fontWeight(FontWeight.SemiBold)
                .lineHeight(1.5)
        }

        Breakpoint.SM {
            Modifier.fontSize(34.px)
        }

        Breakpoint.MD {
            Modifier.fontSize(38.px)
        }
    }

    override val h2 = CssStyle {
        base {
            Modifier
                .fontFamily("FunnelSans-SemiBold")
                .fontSize(20.px)
                .fontWeight(FontWeight.SemiBold)
                .lineHeight(1.5)
        }

        Breakpoint.SM {
            Modifier.fontSize(24.px)
        }

        Breakpoint.MD {
            Modifier.fontSize(28.px)
        }

        Breakpoint.LG {
            Modifier.fontSize(30.px)
        }
    }

    override val body1 = CssStyle {
        base {
            Modifier
                .fontFamily("FunnelSans-Regular")
                .fontSize(16.px)
                .fontWeight(FontWeight.Normal)
                .lineHeight(1.5)
        }

        Breakpoint.SM {
            Modifier.fontSize(17.px)
        }

        Breakpoint.MD {
            Modifier.fontSize(18.px)
        }
    }

    override val body2 = CssStyle {
        base {
            Modifier
                .fontFamily("FunnelSans-Regular")
                .fontSize(14.px)
                .fontWeight(FontWeight.Normal)
                .lineHeight(1.5)
        }

        Breakpoint.SM {
            Modifier.fontSize(15.px)
        }

        Breakpoint.MD {
            Modifier.fontSize(16.px)
        }
    }

    override val body1Medium = CssStyle {
        base {
            Modifier
                .fontFamily("FunnelSans-Medium")
                .fontSize(16.px)
                .fontWeight(FontWeight.Medium)
                .lineHeight(1.5)
        }

        Breakpoint.SM {
            Modifier.fontSize(17.px)
        }

        Breakpoint.MD {
            Modifier.fontSize(18.px)
        }
    }
}